import { render, staticRenderFns } from "./TagInputComponent.vue?vue&type=template&id=d2a64018&scoped=true&"
import script from "./TagInputComponent.vue?vue&type=script&lang=js&"
export * from "./TagInputComponent.vue?vue&type=script&lang=js&"
import style0 from "./TagInputComponent.vue?vue&type=style&index=0&id=d2a64018&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a64018",
  null
  
)

export default component.exports